import { render, staticRenderFns } from "./billing-acts.vue?vue&type=template&id=b751c13e&scoped=true&lang=pug"
import script from "./billing-acts.vue?vue&type=script&lang=js"
export * from "./billing-acts.vue?vue&type=script&lang=js"
import style0 from "./billing-acts.vue?vue&type=style&index=0&id=b751c13e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b751c13e",
  null
  
)

export default component.exports